import makeStyles from '@mui/styles/makeStyles';

export const useHistStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
    },
    hover: {
        padding: 0,
        marginBottom: 10,
        '&:hover': {
            backgroundColor: 'unset',
        },
    },
    attendanceListItem: {
        width: '100%',
        borderRadius: 8,
        overflow: 'hidden',
        backgroundColor: theme.palette.inPatient.formBackground,
        marginBottom: 10,
    },
    attendanceHeader: {
        minHeight: 35,
        padding: 5,
        paddingLeft: 15,
    },
    attendanceDetails: {
        padding: 10,
        paddingLeft: 15,
        backgroundColor: theme.palette.background.paperDarker,
        fontSize: 14,
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        '&.right': {
            marginLeft: 'auto',
        },
    },
    label: {
        fontFamily: 'Inter',
        fontWeight: 'bold',
        marginRight: 5,
        fontSize: 14,
    },
    referral: {
        display: 'inline-block',
        width: 43,
        margin: 1,
        height: 25,
        textAlign: 'center',
        lineHeight: '25px',
        color: '#fff',
        borderRadius: 10,
        fontSize: 'small',
        fontWeight: 'bold',
        marginRight: 5,
        '&.completed': {
            border: '2px solid #000',
            color: '#000',
            lineHeight: '20px',
        },
    },
    avatarCustom: {
        width: 'auto !important',
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 15,
        backgroundColor: theme.palette.background.paper,
        color: '#fff',
    },
    panel: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '16px 10px',
        alignItems: 'center',
        gap: 10,
        height: 55,
        lineHeight: 1,
    },
    discriminator: {
        borderRadius: 6,
        padding: '2px 6px',
    },
    list: {
        height: 'calc(100% - 70px)',
        overflowY: 'auto',
        margin: '0 10px',
    },
    toggleRoot: {
        color: theme.palette.mode === 'dark' ? '#222222' : '#f3f3f4',
        backgroundColor: theme.palette.mode === 'dark' ? '#313233' : '#eff1f3',
        display: 'inline-block',
        width: '100%',
        padding: '5px !important',
    },
    toggleLabel: {
        color: theme.palette.mode === 'dark' ? '#ACAFB3' : '#222222',
        height: '25px !important',
        fontSize: 12,
        '&.icon': {
            fontSize: 10,
        },
        '&.Mui-disabled': {
            border: 'none',
        },
    },
    toggleSelected: {
        color: theme.palette.mode === 'dark' ? '#222222 !important' : '#ffffff !important',
        fontWeight: 700,
        backgroundColor: theme.palette.mode === 'dark' ? '#ffffff !important' : '#626466 !important',
    },
    headerText: {
        color: theme.palette.admissionForm.labelColor,
    },
    block: {
        padding: '5px 10px',
    },
}));